var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.countdownTime ? _c('div', {
    class: _vm.$style.mileContainer,
    on: {
      "click": _vm.openEvent
    }
  }, [_c('div', {
    staticClass: "w-100 h-100"
  }, [_c('VueCountdown', {
    ref: "mileCountdown",
    attrs: {
      "emit-events": "",
      "time": _vm.countdownTime
    },
    on: {
      "progress": _vm.updateCountdown,
      "start": function () {
        _vm.timerStarted = true;
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (props) {
        return [_vm.timerStarted ? _c('div', {
          class: _vm.$style.circlesContainer,
          style: {
            'margin-top': _vm.measureToHeightRatio(32) + 'px',
            'margin-left': -_vm.measureToHeightRatio(-1) + 'px'
          }
        }, [_c('div', {
          staticClass: "position-relative",
          style: {
            width: _vm.measureToHeightRatio(200) + 'px',
            height: _vm.measureToHeightRatio(200) + 'px'
          }
        }, [_c('SvgTimerCircle', {
          attrs: {
            "base-height": _vm.height,
            "desired-height": 200,
            "color": '#147fc3',
            "progress": _vm.daysProgress || Math.ceil(100 * props.days / 109)
          }
        }), _c('p', {
          class: _vm.$style.circleText,
          style: {
            height: _vm.measureToHeightRatio(200) + 'px',
            'font-size': _vm.height / 4.4 + 'px',
            color: '#147fc3'
          }
        }, [_vm._v(_vm._s(props.days))]), _c('p', {
          class: _vm.$style.circleLabel,
          style: {
            'margin-top': -(_vm.height / 66.666) + 'px',
            'font-size': _vm.height / 9.111 + 'px',
            color: '#147fc3'
          }
        }, [_vm._v("DAYS")])], 1), _c('div', {
          staticClass: "position-relative",
          style: {
            width: _vm.measureToHeightRatio(200) + 'px',
            height: _vm.measureToHeightRatio(200) + 'px',
            'margin-right': -_vm.measureToHeightRatio(20) + 'px',
            'margin-left': -_vm.measureToHeightRatio(20) + 'px'
          }
        }, [_c('SvgTimerCircle', {
          attrs: {
            "base-height": _vm.height,
            "desired-height": 200,
            "color": '#ff923f',
            "progress": _vm.hoursProgress || Math.ceil(100 * props.hours / 24)
          }
        }), _c('p', {
          class: _vm.$style.circleText,
          style: {
            height: _vm.measureToHeightRatio(200) + 'px',
            'font-size': _vm.height / 4.4 + 'px',
            color: '#ff923f'
          }
        }, [_vm._v(_vm._s(props.hours))]), _c('p', {
          class: _vm.$style.circleLabel,
          style: {
            'margin-top': -(_vm.height / 66.666) + 'px',
            'font-size': _vm.height / 9.111 + 'px',
            color: '#ff923f'
          }
        }, [_vm._v("HOURS")])], 1), _c('div', {
          staticClass: "position-relative",
          style: {
            width: _vm.measureToHeightRatio(200) + 'px',
            height: _vm.measureToHeightRatio(200) + 'px'
          }
        }, [_c('SvgTimerCircle', {
          attrs: {
            "base-height": _vm.height,
            "desired-height": 200,
            "color": '#64c987',
            "progress": _vm.minutesProgress || Math.ceil(100 * props.minutes / 60)
          }
        }), _c('p', {
          class: _vm.$style.circleText,
          style: {
            height: _vm.measureToHeightRatio(200) + 'px',
            'font-size': _vm.height / 4.4 + 'px',
            color: '#64c987'
          }
        }, [_vm._v(_vm._s(props.minutes))]), _c('p', {
          class: _vm.$style.circleLabel,
          style: {
            'margin-top': -(_vm.height / 66.666) + 'px',
            'font-size': _vm.height / 9.111 + 'px',
            color: '#64c987'
          }
        }, [_vm._v("MINUTES")])], 1)]) : _vm._e()];
      }
    }], null, false, 816102350)
  }), _c('img', {
    class: _vm.$style.mile2026,
    attrs: {
      "src": require("@assets/images/milecountdown2026/mile2026.png"),
      "alt": ""
    }
  })], 1)]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }